import { useEffect } from 'react';
import { useHealth } from './useHealth';

/**
 * Reflète le NOM DU SITE dans le titre d'onglet (`document.title`).
 *
 * La source est `useHealth().name` — l'endpoint `/api/health` est PUBLIC, donc le
 * titre est correct même sur l'écran de LOGIN (pré-auth) et suit le réglage global.
 * Monté HAUT dans l'arbre (`App`) pour couvrir toutes les routes. Le `<title>`
 * statique de `index.html` (« xfile ») sert de repli avant que `/api/health` n'ait
 * répondu — on ne l'écrase que lorsqu'un nom est connu.
 */
export function useDocumentTitle(): void {
  const { health } = useHealth();
  const name = health?.name;
  useEffect(() => {
    if (name) document.title = name;
  }, [name]);
}
